<template lang="pug">
  #app
    v-app
      Header
      v-layout.pb-4(row, wrap, justify-center)
        v-flex(xs8)
          v-layout(row, wrap)
            v-flex(xs6)
              v-card(to="/", v-bind:class="{ active: path === '/' }")
                p.text-xs-center.mb-0 Mapa
            v-flex(xs6)
              v-card(to="/chart", v-bind:class="{ active: path === '/chart' }")
                p.text-xs-center.mb-0 Gráficas
      v-layout(row, wrap)
          v-flex(xs12)
            Options
      router-view
</template>

<script>
import Header from "@/components/Header.vue";
import Options from "@/components/Options.vue";

export default {
  name: "App",
  components: {
    Header,
    Options,
  },
  data() {
    return {
      path: "",
    };
  },
  methods: {
    getReports() {
      this.$store.dispatch("getPublicReports");
    },
    getContexts() {
      this.$store.dispatch("getContexts");
    },
  },
  updated() {
    if (this.$route.fullPath === "/") {
      this.path = this.$route.fullPath;
    } else if (this.$route.fullPath === "/chart") {
      this.path = this.$route.fullPath;
    }
  },
  mounted() {
    //this.getReports();
    if (this.$route.fullPath === "/") {
      this.path = this.$route.fullPath;
    } else if (this.$route.fullPath === "/chart") {
      this.path = this.$route.fullPath;
    }
  },
  // eslint-disable-next-line
  async created() {
    await this.getReports();
    await this.getContexts();
  },
};
</script>

<!--<style src="./app.scss" lang="scss">
</style>-->

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Rajdhani:300,400,500,600,700");
@import url("https://fonts.googleapis.com/css?family=Barlow:300,400,500,600,700,800");
@import "~vuetify/dist/vuetify.min.css";
@import "~material-design-icons-iconfont/dist/material-design-icons.css";
@import "~leaflet/dist/leaflet.css";

body {
  margin: 0px;
}

#app {
  .layout.pb-4 {
    background-color: #212a2e;
    a.card {
      border-radius: 0px;
      background-color: #96a93f;
      font-family: "Rajdhani", sans-serif;
      color: white;
      font-weight: 700;
      font-size: 35px;
      &:hover {
        background-color: #96a93f55;
        color: #ffffff55;
      }
    }
  }
  .active {
    background-color: #96a93f55 !important;
    border-color: #ffffff55 !important;
  }
}
</style>
